// Selectors
import { getSelectedElementIds } from './selection/selectedElementsSelector';
import { getPresentationModeIsFocusModeAllowed } from '../workspace/presentation/presentationSelector';

// Actions
import { updateElement } from './actions/elementActions';
import { showGuestAppRegistrationForm } from '../reducers/guestNavigationActions';
import { focusElementStart } from '../workspace/presentation/presentationActions';
import {
    finishEditingElement,
    setSelectedElements,
    startEditingElement,
    toggleSelectedElements,
} from './selection/selectionActions';

export default (dispatch) => ({
    dispatchUpdateElement: ({ id, changes, sync, analyticsEvent, transactionId }) =>
        dispatch(updateElement({ id, changes, sync, analyticsEvent, transactionId })),
    dispatchGetSelectedElementIds: () => dispatch((_, getState) => getSelectedElementIds(getState())),
    dispatchSetSelectedElements: (ids) => dispatch(setSelectedElements({ ids })),
    dispatchToggleSelectedElements: (ids) => dispatch(toggleSelectedElements({ ids })),
    dispatchStartEditingElement: ({ id, editorId, editorKey }) =>
        dispatch(startEditingElement({ id, editorId, editorKey })),
    dispatchStopEditing: (id) => dispatch(finishEditingElement(id)),
    dispatchShowGuestAppRegistrationForm: () => dispatch(showGuestAppRegistrationForm()),
    dispatchFocusElementStart: (elementId, initialZoomScale, elementProps) => {
        dispatch(focusElementStart(elementId, initialZoomScale, elementProps));
        dispatch(finishEditingElement(elementId));
    },
    dispatchGetPresentationModeIsFocusModeAllowed: () =>
        dispatch((_, getState) => getPresentationModeIsFocusModeAllowed(getState())),
});
